import React, { Fragment } from 'react';

const MiniCartProduct = ({
    product,
    onCartItemIncrement,
    onCartItemDecrement,
    onCartItemRemove,
    showStock
}) => (
    <div className="cart__product-row">
        <div className="cart__product-row__image">
            <a href={product.url}><img src={product.image} alt={product.name} /></a>
        </div>
        <div className="cart__product-row__info">
            <div className="cart__split-row">
                <div className="cart__product-row__articleno">{product.articleNumber}</div>
                <button className="cart__product-row__remove-button" onClick={onCartItemRemove}><i className="table__icon table__icon--delete" ></i></button>
            </div>
            <div className="cart__split-row">
                <h3><a href={product.url}>{product.name} {product.nameAdditionalData}</a></h3>
            </div>
            {showStock && 
                <div className="cart__stock-status-info">
                {product.isInStock ?
                    <Fragment>
                        <link itemProp="availability" href="http://schema.org/InStock" />
                        <div className="cart__stock-status-info"><span className="cart__stock-status-info--in-stock"></span>{product.stockStatusDescription}</div>
                    </Fragment>
                    :
                    <Fragment>
                        <link itemProp="availability" href="http://schema.org/OutOfStock" />
                        <div className="cart__stock-status-info"><span className="cart__stock-status-info--out-of-stock"></span>{product.stockStatusDescription}</div>
                    </Fragment>
                }
            </div>            
            }            
            <div className="cart__product-row__price">
                {product.campaignPrice ? (
                    <Fragment>
                        <span className="product__campaign-price" dangerouslySetInnerHTML={{ __html: product.campaignPrice }}></span >&nbsp;<span className="product__old-price" dangerouslySetInnerHTML={{ __html: product.price }}></span>
                    </Fragment>
                ) : <span dangerouslySetInnerHTML={{ __html: product.price }}></span>}
            </div>
            <div className="cart__product-row__quantity">
                <button
                    className="cart__product-row__quantity-action decrease"
                    onClick={onCartItemDecrement}>
                    <span>-</span>
                </button>
                <div className="cart__product-row__quantity-display">
                    <span>{product.quantity}</span>
                </div>
                <button
                    className="cart__product-row__quantity-action cart__product-row__quantity-action--plus increase"
                    onClick={onCartItemIncrement}>
                    <span>+</span>
                </button>
            </div>
        </div>
    </div>
);

export default MiniCartProduct